import React, {FunctionComponent} from 'react'
import StylesType from '@/types/StylesType'
import classnames from 'classnames'
import {Link} from 'react-router-dom'
import './style/ServiceItem.less'
import report from "@/utils/log";

export interface ServiceItemTypes {
  img: string;
  title: string;
  productLink: string;
  buyToLink: string;
  desc: string;
  onclick?:()=>void
}

export type ServiceItemType = StylesType & ServiceItemTypes

export const ServiceItem: FunctionComponent<ServiceItemType> = props => {
  const {prefixCls = 'gc_', className, img, title, productLink, desc, buyToLink, onclick} = props

  return (
    <div className={classnames(prefixCls + 'service_item', className)}>
      <img src={img} className={classnames('backImg')} alt=''/>
      <div className={classnames('item_bottom')}>
        <div className={classnames('title')}><span>{title}</span><Link to={productLink}>产品说明>></Link></div>
        <div className={classnames('desc')}>{desc}</div>
        <Link className={classnames('to_buy')} to={buyToLink} onClick={() => onclick&&onclick()}>购买服务</Link>
      </div>
    </div>
  )
}

const Services: FunctionComponent<StylesType> = props => {
  const {className, prefixCls = 'gc_'} = props
  const services: ServiceItemTypes[] = [{
    img: require('../../assets/service/newMachineInto.png'),
    title: '一键新机服务',
    productLink: '/Home/NewMachinePro',
    buyToLink: '/Home/NewMachine',
    desc: '修改手机参数，一键生成全新配置手机参数',
    onclick:function () {
      report({
        eventId: 'E0410',
        pageId: 'P04',
        ext: '',
      })
    }
  }, {
    img: require('../../assets/service/IPInto.png'),
    title: 'IP代理服务',
    buyToLink: '/Home/IPService',
    productLink: '/Home/IPServicePro',
    desc: '修改手机出口IP，降低风控风险',
    onclick:function () {
      report({
        eventId: 'E0409',
        pageId: 'P04',
        ext: '',
      })
    }
  }]
  return (
    <div className={classnames(prefixCls + 'services', className)}>
      {services.map((service, index) => {
        return <ServiceItem {...service} key={index}></ServiceItem>
      })}
    </div>
  )
}

export default Services
